<template>
  <div>
    <common-dialog v-dialog-drag :modal-append-to-body="false" center :width="hasMembers ? '90%' : '80%'" :border="false" :close-on-click-modal="false"
                   :visible="dialogVisible" @close="changePostCreateVisible(false)" class="spec-dialog">
      <span slot="title">{{title}}</span>
      <div class="content-panel">
        <div class="left-panel" :style="hasMembers ? 'width: 70%' : 'width: 100%'">
          <article-major-content ref="majorContent" :hasCaseShare="hasCaseShare" :hasAttachment="hasAttachment"/>
        </div>
        <div v-if="hasMembers" class="right-panel">
          <article-member-invite ref="memberContainer" :participant.sync="members"/>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
           <common-button @click="changePostCreateVisible(false)" class="operation-btn" type="cancel">取消</common-button>
           <common-button @click="handleSavePostDraft(dialogData.urgency)" type="warn" class="operation-btn">存为草稿</common-button>
           <common-button @click="handleSavePostInfo" type="primary" class="operation-btn">发布</common-button>
           <common-button type="primary"
                         v-if="hasMembers"
                         @click="handleAddMember"
                         class="operation-btn">
             勾选参与人
           </common-button>
           <el-switch
             v-model="dialogData.urgency"
             active-text="加急发布">
           </el-switch>
      </span>
    </common-dialog>

    <participant-drawer ref="participantDrawer" v-if="dialogVisible" :visible.sync="selectMemberVisible" @callback="handleCallback">
    </participant-drawer>

    <animation :loadingDataVisible="isLoading" :loadingText="loadingText"/>
  </div>
</template>

<script>
  import ArticleMajorContent from "../article/ArticleMajorContent";
  import ArticleAttachmentUpload from "../article/ArticleAttachmentUpload";
  import ArticleMemberInvite from "../article/ArticleMemberInvite";
  import {Message} from "element-ui";
  import cookie from "@/utils/cookie";
  import http from '@/utils/axios'
  import animation from '@/components/loading/animation'
  import {articleMixin} from '../../pages/mixins/articleMixin'
  import ParticipantDrawer from "./ParticipantDrawer";
    export default {
      name: "PostUpdate",
      components: {ParticipantDrawer, ArticleMemberInvite, ArticleAttachmentUpload, ArticleMajorContent, animation},
      mixins:[articleMixin],

      props: {
        title:{
          type: String,
          default: "修改文章",
        },

        hasAttachment: {
          type: Boolean,
          default: false,
        },

        hasMembers: {
          type: Boolean,
          default: false,
        },

        baseUrl: {
          type: String,
          default: null,
        },
        baseUrlUpdate: {
          type: String,
          default: null,
        },
        postCode: {
          type: String,
          default: null,
        },
        postTpCode: {
          type: String,
          default: null,
        },

        status: {
          type: String,
        },

        hasCaseShare: {
          type: Boolean,
          default: false,
        },
      },
      data() {
        return {
          selectMemberVisible: false,
          members: [],
          loadingText: null,
          dialogVisible: false,
          dialogData: {},
          isLoading: false,
          articledata:{},
          articleStatus: this.status,

          deptPower: false,
          systemPower: false,
          superPower: false,
        }
      },

      watch:{
        dialogVisible(newVal){
          if (newVal){
            this.queryData()
          }
        }
      },
      created() {
        this.dialogVisible = true

        this.systemPower = this.$store.state.userPowerStore.systemPower
        this.superPower = this.$store.state.userPowerStore.superPower
        this.deptPower = this.$store.state.userPowerStore.deptPower
      },

      methods: {

        handleCallback(data, checkNodes){
          this.members = []
          this.recursionMemberData(checkNodes)
          this.members = this.members.filter(item =>{
            return item.isMember
          })

        },

        recursionMemberData(items) {
          for (let item of items) {
            if (item.isMember) {
              item.userId = item.id
              this.members.push(JSON.parse(JSON.stringify(item)))
            }
            if (item.children && item.children.length !== 0) {
              this.recursionMemberData(item.children)
            }
          }
        },

        handleAddMember(){
          let members = JSON.parse(JSON.stringify(this.members))
          this.$refs.participantDrawer.membersCopy = members
          this.$refs.participantDrawer.members = members
          this.selectMemberVisible = true
        },

        queryData(){
          let _this = this;
          this.isLoading = true;
          this.loadingText = "加载中"
          http.post(window.config.api.baseUrl +_this.baseUrl , {
            token: cookie.getCookie("token"),
            data: {
              postCode: _this.postCode,
              postTpCode: _this.postTpCode,
              status: _this.status,
            }
          }).then((response) => {
            let data = response.data.data;
            _this.articledata= data.article;
            _this.$refs.majorContent.post.postTitle = _this.articledata.postTitle
            _this.$refs.majorContent.post.postContent = _this.articledata.postContent
            _this.$refs.majorContent.post.totalAttaSize = _this.articledata.totalAttaSize
            _this.$refs.majorContent.post.postCode = _this.articledata.postCode
            _this.$refs.majorContent.post.postTpCode = _this.articledata.postTpCode
            _this.$refs.majorContent.post.createUserId = _this.articledata.createUserId
            _this.$refs.majorContent.post.createTm = _this.articledata.createTm
            _this.$refs.majorContent.post.attachments = _this.articledata.attachments?_this.articledata.attachments:[]
            let users = _this.articledata.members;
            for (let user of users) {
              user.isMember = true
            }
            this.members = users
          }).finally(() => {
            _this.isLoading = false;
          })

        },

        //存为草稿数据
        handleSavePostDraft(data){
          if(data){
            Message.error({message: "当保存为草稿时不可以选择加急发布"})
            return false
          }
          //设置为保存草稿数据
          this.articleStatus = this.APPROVE_STATUS_DRAFT
          this.savePostInfo()
        },

        //正式发布数据
        handleSavePostInfo() {
          this.articleStatus = this.APPROVE_STATUS_NOT
          this.savePostInfo()
        },

        /**
         * 将tree格式的成员数据转化成偏平状的数据
         */
        delayeringMemberData() {
          this.dialogData.members = []
          for (let member of this.members) {
            member.userId = member.id
            this.dialogData.members.push(member)
          }
          // this.recursionMemberData(this.participant)
        },


        //发送请求保存数据
        savePostInfo() {
          if (this.hasAttachment) {
            this.$refs.majorContent.getArticleData(this.dialogData)
            if (this.hasMembers) {
              //将成员的数据设置到this.dialogData里面(从tree格式转化成扁平化方式的)
              this.delayeringMemberData()
            }
            this.hasAttachmentSave();
          } else {
            let that = this
            this.$refs.majorContent.getArticleData(this.dialogData)

            this.isLoading = true
            const paramsData = new FormData();
            let jsonData = {
              token: cookie.getCookie("token"),
              data: {
                attachment: this.dialogData.attachments,
                cd: this.discussAttachmentCode,

                article: {
                  ...this.dialogData,
                  "postTitle": this.dialogData.postTitle,
                  "postContent": this.dialogData.postContent,
                  "status": this.articleStatus,
                  "postCode": this.postCode,
                  "postTpCode": this.postTpCode,
                }
              }
            }
            this.loadingText = "处理中"
            paramsData.append('data', new Blob([JSON.stringify(jsonData)], {type: "application/json"}));
            http.post(window.config.api.baseUrl + that.baseUrlUpdate, paramsData).then(value => {
              if (value.data.code === '00000') {
                if('3'==this.articleStatus){
                  Message.success("文章信息修改成功")
                }else{
                  if (this.superPower || this.systemPower || this.deptPower) {
                    Message.success("文章已经发布")
                  } else {
                    Message.success("文章已经提交审核")
                  }
                }

                that.$emit("refresh")
                that.dialogVisible = false
              }else{
                that.$emit("sensitiveWord",value.data.data.sensitiveWord)
              }
            }).finally(() => {
              that.isLoading = false;
            })
            // let obj = {
            //   token: cookie.getCookie("token"),
            //   data: {
            //     "postTitle": this.dialogData.postTitle,
            //     "postContent": this.dialogData.postContent,
            //     "status": this.articleStatus,
            //     "postCode": this.postCode,
            //     "postTpCode": this.postTpCode,
            //   }
            // }
            // http.post(window.config.api.baseUrl + that.baseUrlUpdate, obj).then(response => {
            //   if (response.data.code === '00000') {
            //     Message.success("文章信息修改成功")
            //     that.$emit("refresh")
            //     that.dialogVisible = false
            //
            //   } else {
            //     that.$emit("sensitiveWord", response.data.data.sensitiveWord)
            //   }
            // }).finally(() => {
            //
            //   that.isLoading = false
            // })
          }
        },

        hasAttachmentSave(){
          Message.info("数据导入可能需要几分钟,请耐心等待")
          let that = this
          // 使用form表单的数据格式
          const paramsData = new FormData();
          this.dialogData.users =  this.hasMembers?JSON.parse(JSON.stringify(this.dialogData.members)):null;
          // 将上传文件数组依次添加到参数paramsData中
          this.dialogData.attachmentsMultipart.forEach((it, index) => {
            paramsData.append(`file`, it.file)
          });
          if (this.dialogData.attachmentsMultipart.length === 0) {
            paramsData.append(`file`, null)
          }
          let jsonData = {
            token: cookie.getCookie("token"),
            data: {
              attachment: this.dialogData.attachments,
              cd: this.discussAttachmentCode,
              members: this.dialogData.members,

              article: {
                ...this.dialogData,
                "postTitle": this.dialogData.postTitle,
                "postContent": this.dialogData.postContent,
                "status": this.articleStatus,
                "postCode": this.postCode,
                "postTpCode": this.postTpCode,
              }
            }
          }
          //将表单数据添加到参数paramsData中,需要将参数转化成Blob后端才能识别到文件
          paramsData.append('data', new Blob([JSON.stringify(jsonData)], {type: "application/json"}));
          // 表单数据和文件一起上传,调用后端接口
          this.loadingText = "处理中"
          this.isLoading = true
          http.post(window.config.api.baseUrl + that.baseUrlUpdate, paramsData).then(value => {
            if (value.data.code === '00000') {
              if('3'==this.articleStatus){
                Message.success("文章信息修改成功")
              }else{
                if (this.superPower || this.systemPower || this.deptPower) {
                  Message.success("文章已经发布")
                } else {
                  Message.success("文章已经提交审核")
                }
              }
              that.$emit("refresh")
              that.dialogData = this.$options.data().dialogData
            }else{
              that.$emit("sensitiveWord",value.data.data.sensitiveWord)
            }
          }).finally(() => {
            that.isLoading = false;
            that.dialogVisible = false;
          })
        },
        changePostCreateVisible(flag) {
          this.dialogData = this.$options.data().dialogData
          this.dialogVisible = flag
          this.$emit("handlerVisible", flag)
        }


      },


    }
</script>

<style scoped>

/deep/ .el-dialog--center {
  height: 80vh;
  /*设置弹窗dialog的默认高度*/
  min-height: 70vh;
  display: flex;
  flex-direction: column;
}

/deep/ .el-dialog__body {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 0;
}

.content-panel {
  flex: 1;
  display: flex;
  flex-direction: row;
  height: 100%;
}

.left-panel,.right-panel {
  margin: 0 10px;
}

.left-panel, .right-panel {
  margin: 0 10px;
}

.right-panel {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.operation-btn {
  margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/detail/PostUpdate.vue